"use client";

import { ArrowRight, ArrowUpRight } from "lucide-react";
import { useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Componenti() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const pillars = [{
    number: "01",
    category: "TECNOLOGIA HVAC",
    title: "CONDOTTI ARIA",
    description: "Riqualificazione igienico-funzionale di reti aerauliche mediante tecnologie di bonifica specialistica.",
    bullets: ["Ispezione video robotizzata", "Rimozione depositi tecnici", "Sanificazione certificata"],
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/condotti_hvac_acciaio_zincato_manutenzione.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/condotti_hvac_acciaio_zincato_manutenzione.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/condotti_hvac_acciaio_zincato_manutenzione.webp-wvc-sizes"
  }, {
    number: "02",
    category: "ESTRAZIONE FUMI",
    title: "CAPPE PROFESSIONALI",
    description: "Riqualificazione igienico-funzionale di cappe e sistemi di estrazione per cucine industriali e mense.",
    bullets: ["Bonifica filtri e plenum", "Manutenzione ventilatori", "Ripristino efficienza flussi"],
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/cappa_professionale_acciaio_inox_brillante.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/cappa_professionale_acciaio_inox_brillante.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/cappa_professionale_acciaio_inox_brillante.png-wvc-sizes"
  }, {
    number: "03",
    category: "FILTRAZIONE ARIA",
    title: "SISTEMI DI ASPIRAZIONE",
    description: "Riqualificazione igienico-funzionale di UTA, ventilatori e componenti tecnici per l'ottimizzazione della qualità dell'aria.",
    bullets: ["Sostituzione filtri tecnici", "Analisi portate d'aria", "Report fotografico finale"],
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/filtri_aria_hepa_h14_sostituzione.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/filtri_aria_hepa_h14_sostituzione.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/filtri_aria_hepa_h14_sostituzione.webp-wvc-sizes"
  }];
  return <section data-section-id="2698" id="componenti-e-filtrazione" className="bg-background text-foreground py-20 md:py-28 px-4 md:px-8 lg:px-12">
      <div className="max-w-[1400px] mx-auto">
        <div ref={headerRef} className={`mb-12 md:mb-16 transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="font-mono text-xs md:text-sm tracking-widest text-muted-foreground mb-8 md:mb-12">
            03 / DIVISIONE TECNICA
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-end">
            <h2 className="font-default lg:col-span-8 text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold leading-[0.9] tracking-tight uppercase text-secondary">
              SOLUZIONI{" "}
              <span className="inline-block text-transparent" style={{
              WebkitTextStroke: "1.5px currentColor"
            }}>
                IMPIANTISTICHE
              </span>
            </h2>

            <div className="lg:col-span-4 lg:text-right flex flex-col gap-4 lg:items-end">
              <p className="font-default text-sm md:text-base text-muted-foreground max-w-sm">
                Interventi specialistici per la riqualificazione igienico-funzionale di impianti aria e sistemi di estrazione.
              </p>
              <Link to="/TechnicalDivisionPage" className="inline-flex items-center gap-2 font-mono text-xs tracking-widest uppercase text-foreground hover:text-primary transition-colors group">
                SCOPRI TUTTO
                <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>
          </div>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 gap-6 transition-all duration-1000 ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {pillars.map((pillar, i) => {
          const isHovered = hoveredIndex === i;
          return <div data-index={i} key={pillar.number} onMouseEnter={() => setHoveredIndex(i)} onMouseLeave={() => setHoveredIndex(null)} className="relative group h-[600px] overflow-hidden rounded-lg cursor-pointer transition-all duration-500 border border-border/60 shadow-xl" style={{
            transform: isHovered ? "scale(1.02)" : "scale(1)",
            border: isHovered ? "1px solid var(--primary)" : "1px solid var(--border)",
            boxShadow: isHovered ? "0 0 16px 0 var(--primary)" : "none"
          }}>
                <img src={pillar.image} data-wvc-srcset={pillar.srcset} data-wvc-sizes={pillar.sizes} alt={pillar.title} loading="lazy" decoding="async" className={`absolute inset-0 w-full h-full object-cover transition-all duration-700 ${isHovered ? "saturate-50" : "saturate-100"}`} />

                <div className="absolute inset-0" style={{
              background: "linear-gradient(to top, hsl(222 47% 7% / 0.95) 0%, hsl(222 47% 7% / 0.7) 40%, hsl(222 47% 7% / 0.2) 100%)"
            }} />

                <div className="absolute left-0 top-0 bottom-0 w-px bg-border" />
                <div className="absolute left-4 top-1/2 -translate-y-1/2 origin-center -rotate-90 whitespace-nowrap">
                  <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground">
                    {pillar.category}
                  </span>
                </div>

                <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-8 pl-12 md:pl-14">
                  <div className="font-mono text-sm tracking-widest text-primary mb-6">
                    {pillar.number}
                  </div>

                  <h3 className="font-default text-3xl md:text-4xl font-bold uppercase tracking-tight mb-4 text-white group-hover:text-secondary transition-colors duration-300">
                    {pillar.title}
                  </h3>

                  <p className="font-default text-sm text-white/80 leading-relaxed max-w-xs mb-4">
                    {pillar.description}
                  </p>

                  <div className={`overflow-hidden transition-all duration-500 ${isHovered ? "max-h-40 opacity-100 mb-6" : "max-h-0 opacity-0 mb-0"}`}>
                    <ul className="space-y-2 pt-2 border-t border-white/20">
                      {pillar.bullets.map((bullet, j) => <li key={j} className="font-mono text-xs text-white/70 flex items-start gap-2 pt-2">
                          <span className="text-primary mt-0.5">/</span>
                          <span>{bullet}</span>
                        </li>)}
                    </ul>
                  </div>

                  <div className="flex justify-end">
                    <Button size="icon" variant="outline" aria-label={`Approfondisci ${pillar.title}`} className={`rounded-lg size-12 border-white/40 bg-transparent transition-all duration-300 ${isHovered ? "bg-primary border-primary text-secondary-foreground hover:bg-primary" : "text-white hover:bg-white/10"}`}>
                      <ArrowUpRight className="size-5" />
                    </Button>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}